import AboutMeComponent from "../../components/about/AboutMeComponent"

export default function AboutMe() {
    return <AboutMeComponent />
}